import { render } from "./Forgot.vue?vue&type=template&id=622cdcf4&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"

import "./Forgot.vue?vue&type=style&index=0&id=622cdcf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-622cdcf4"

export default script